import { NavbarItem } from 'interfaces/navbar';

export const getOptions = (options: NavbarItem[], menuLabels: string[]) =>
  options.filter((item) => menuLabels.indexOf(item.label) > -1);
